/**
 * LES TRAMES D'ÉTAT DU PARCELLAIRE — item D.947.
 *
 * ⚠️⚠️ LA COULEUR NE PORTE JAMAIS SEULE. `signatures-plan.ts` tient cette
 * doctrine pour les TRAITS (épaisseur × motif, à la manière de swisstopo et
 * d'ALKIS) ; les APLATS des quatre états de parcelle, eux, n'étaient encodés
 * QUE par la teinte (`couleurStatut`). Retirez la couleur — photocopie, agent
 * daltonien, écran en plein soleil — et « inscrite » ne se distingue plus de
 * « suspendue ». Chaque état porte donc une TRAME en plus de sa couleur, et
 * le plein EST une trame : celle de l'état inscrit, le seul qui engage.
 *
 * ⚠️ UNE SEULE TABLE, DEUX LECTEURS. La carte peint ces trames (fill-pattern)
 * et la légende les décrit : deux listes divergeraient au premier état ajouté
 * — c'est le motif « légende qui retape les couleurs » déjà payé ici.
 *
 * ⚠️ LA LÉGENDE NOMME LA COULEUR RÉELLEMENT PEINTE. `couleurNom` est confronté
 * par un banc à la TEINTE du jeton de `socle.css` (hex → famille de teinte) :
 * un libellé qui annonce « vert » sur un jeton rouge rougit. Une légende crue
 * est pire qu'une absence de légende.
 */

export type EtatParcelle = 'active' | 'en_instruction' | 'suspendue' | 'projet';
export type TrameEtat = 'plein' | 'hachures' | 'croisillons' | 'points';

export const TRAMES_ETAT: Record<EtatParcelle, {
  libelle: string;
  trame: TrameEtat;
  /** Le nom français de la teinte du jeton — vérifié contre socle.css. */
  couleurNom: string;
}> = {
  active: { libelle: 'inscrite', trame: 'plein', couleurNom: 'vert' },
  en_instruction: { libelle: 'en instruction', trame: 'hachures', couleurNom: 'ambre' },
  suspendue: { libelle: 'suspendue', trame: 'croisillons', couleurNom: 'rouge' },
  projet: { libelle: 'en projet — non opposable', trame: 'points', couleurNom: 'gris' },
};

/** Le nom d'image MapLibre d'une trame — stable, le style s'y réfère. */
export const nomImageTrame = (t: Exclude<TrameEtat, 'plein'>) => `trame-${t}`;
